"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _globalComponentsLibrary = require("global-components-library");
var _reactI18next = require("react-i18next");
var _filePreviewPh = _interopRequireDefault(require("../../images/file-preview-ph.svg"));
require("./MediaViewerAttachment.scss");
var _helpers = require("../../utils/helpers");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var MediaViewerAttachment = function MediaViewerAttachment(_ref) {
  var toggle = _ref.toggle,
    media = _ref.media,
    mediaType = _ref.mediaType,
    fileName = _ref.fileName,
    fileSize = _ref.fileSize;
  var _useTranslation = (0, _reactI18next.useTranslation)('media-viewer'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-media-viewer-attach"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-media-viewer-header"
  }, mediaType === 'file' && /*#__PURE__*/_react["default"].createElement("span", {
    className: "uin-media-viewer-title"
  }, fileName), /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.ButtonIcon, {
    icon: "close",
    onClick: toggle
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-media-viewer-content"
  }, {
    image: /*#__PURE__*/_react["default"].createElement("img", {
      src: media,
      alt: fileName
    }),
    video: /*#__PURE__*/_react["default"].createElement("video", {
      preload: "auto",
      controls: true,
      src: media
    }),
    audio: /*#__PURE__*/_react["default"].createElement("audio", {
      preload: "auto",
      controls: true,
      src: media
    }),
    file: /*#__PURE__*/_react["default"].createElement("div", {
      className: "uin-media-viewer-file"
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: _filePreviewPh["default"],
      alt: "file"
    }), /*#__PURE__*/_react["default"].createElement("span", {
      className: "uin-media-viewer-label"
    }, t('no-preview')), /*#__PURE__*/_react["default"].createElement("span", {
      className: "uin-media-viewer-data"
    }, typeof fileSize === 'number' ? (0, _helpers.fileSizeReadable)(fileSize) : fileSize, " - ", (0, _helpers.fileExtension)(fileName).toUpperCase()))
  }[mediaType]));
};
MediaViewerAttachment.propTypes = {
  toggle: _propTypes["default"].func.isRequired,
  media: _propTypes["default"].string.isRequired,
  fileName: _propTypes["default"].string,
  fileSize: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  mediaType: _propTypes["default"].oneOf(['image', 'video', 'audio', 'file']).isRequired
};
MediaViewerAttachment.defaultProps = {
  mediaType: 'file',
  fileSize: '0 kB'
};
var _default = exports["default"] = MediaViewerAttachment;


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/MediaViewer/MediaViewerAttachment.js
// module id = 1416
// module chunks = 0